// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1499":"8cb7874f","5761":"cc96f4b2"}[chunkId] + ".chunk.css";
};